export default __webpack_public_path__ + "5b2c11c258c29ab9c51f37e9c8d67e1a.png";